import { type MenuProps, Menu as MuiMenu } from '@mui/material';

export const Menu = (props: MenuProps) => <MuiMenu {...props} />;
